const HTTPErrors = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
}

const getHTTPErrorType = (error, compareWith: keyof typeof HTTPErrors) => {
  const target = HTTPErrors?.[compareWith || 'INTERNAL_SERVER_ERROR']

  return (
    error?.code === target.toString() ||
    error?.response?.status === target ||
    error?.message?.includes(target.toString())
  )
}

export default getHTTPErrorType
